<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import perfilesCargoAPI from "../../../services/standards/perfilesCargo/perfilesCargoAPI";
import PerfilesCargoPagination from "../../../components/standard/perfilesCargo/PerfilesCargoPagination.vue";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Perfiles de cargo - profesiograma",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    PerfilesCargoPagination,
  },
  data() {
    return {
      title: "3.1.3 Perfiles de cargo - profesiograma",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Perfiles de cargo - profesiograma",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      types: [],
      lista: [],
      loading: true,
      loading2: true,
      acta: null,
      profesiograma: null,
      deleteCount: 0,
      itemData: null,

      item: null,
      itemStatus: "No cumplido",

      search: "",

      itemData: null,

      file: null,

      perfil: {
        position: null,
        description_position: null,
        evaluations_types_id: [],
        frequency: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },

  validations: {
    perfil: {
      position: {
        required,
      },
      description_position: {
        required,
      },
      evaluations_types_id: {
        required,
      },
      frequency: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(25)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 25)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 25,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getType() {
      perfilesCargoAPI
        .getTypes()
        .then((response) => {
          this.loading = false;
          let types = response.data;
          this.types = types;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    save() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        perfilesCargoAPI
          .save(this.perfil)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 25,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(57, 25, true);
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      }
    },

    deleteEvaluacion(id) {
      perfilesCargoAPI
        .delete(id, this.companyID)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 20,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "Se ha sido eliminado con exito!",
                  icon: "success",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });

        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      perfilesCargoAPI
        .get(this.companyID)
        .then((response) => {
          let identificacion = response.data.data;
          this.lista = identificacion;
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getE() {
      try {
        perfilesCargoAPI.getExcel(this.companyID).then((response) => {
          this.profesiograma = response;
        });
      } catch (error) {
        console.log(error);
      }
    },

    async print() {
      try {
        perfilesCargoAPI.getExcel(this.companyID).then((response) => {
          this.profesiograma = response;
        });
        const url = this.profesiograma;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getItems();
    this.getList();
    this.getItemData();
    this.getType();
    this.getE();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá definir las evaluaciones médicas
                      ocupacionales que se requieren para cada uno de los cargos
                      existentes. Para definir los tipos de evaluaciones, es
                      necesario contar con el perfil del cargo, donde se
                      especifiquen las funciones y adicional a esto, conocer los
                      peligros y riesgos de la empresa y así poder determinar
                      que se debe evaluar, este consolidado de las evaluaciones
                      será el Profesiograma. El profesiograma deberá ser
                      revisado por un médico de SST y entregado a la IPS que
                      realiza las evaluaciones médicas ocupacionales para
                      informarle los tipos de exámenes a realizar. Cada vez que
                      se cambie un cargo o se identifique un nuevo riesgo para
                      los trabajadores, deberá revisarse el profesiograma y
                      actualizarlo si es necesario.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-8 text-right m-b-0"></div>
                <div class="col-4 text-right m-b-0">
                  <button :disabled="!allowAccess()" type="button" class="btn btn-primary mx-1">
                    <router-link class="text-white" :to="{
                      path: `/forms/estandares/${this.companyID}/evidencia-profesiograma`,
                    }"><span class="btn-label"></span>Ver evidencias
                    </router-link>
                  </button>

                  <br />
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Tipos de evaluaciones">
                    <table
                      class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="dato in types" :key="dato.id">
                          <td>
                            {{ dato.name }}
                          </td>
                          <td class="text-center align-middle">
                            <input :disabled="!getRole('Crear') || !allowAccess()" type="checkbox" style="color: #666"
                              :value="dato.id" class="mb-2 mr-sm-2 mb-sm-0" label="accidente"
                              v-model="perfil.evaluations_types_id" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-if="submitted && $v.perfil.evaluations_types_id.$error">
                      <small v-if="!$v.perfil.evaluations_types_id.required" class="text-danger">
                        <b>Seleccionar mínimo un tipo de evaluación</b>
                      </small>
                    </div>

                    <div v-if="submitted && $v.perfil.evaluations_types_id.$error">
                      <small v-if="!$v.perfil.evaluations_types_id" class="text-danger">
                        <b>El tipo de cambio es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-4 px-2 mb-3" label="Frecuencia">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="perfil.frequency" :class="{
                        'is-invalid': $v.perfil.frequency.$error && submitted,
                      }">
                      <b-form-select-option value="Anual">
                        Anual
                      </b-form-select-option>
                      <b-form-select-option value="Dos años">
                        Dos años
                      </b-form-select-option>
                      <b-form-select-option value="Tres años">
                        Tres años
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.perfil.frequency.$error">
                      <small v-if="!$v.perfil.frequency.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2 mb-3" label="Cargo" label-for="file">
                    <b-form-input :disabled="!getRole('Crear') || !allowAccess()" type="text" id="date_exam"
                      maxlength="50" v-model="perfil.position" :class="{
                        'is-invalid': $v.perfil.position.$error && submitted,
                      }">
                    </b-form-input>
                    <div v-if="submitted && $v.perfil.position.$error">
                      <small v-if="!$v.perfil.position.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Descripción del cargo" label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate"
                      v-model="perfil.description_position" maxlength="200" :class="{
                        'is-invalid':
                          $v.perfil.description_position.$error && submitted,
                      }">
                      >
                    </b-form-textarea>
                    <div v-if="submitted && $v.perfil.description_position.$error">
                      <small v-if="!$v.perfil.description_position.required" class="text-danger">
                        <b>La descripción es requerida</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-10">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <!-- <div class="col-2">
                          <a href="#" @click="print">
                            Exportar profesiograma
                          </a>
                        </div> -->
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Cargo</th>
                              <th class="text-center align-middle">
                                Descripción del cargo
                              </th>
                              <th class="align-middle">
                                Tipos de evaluaciones
                              </th>
                              <th class="text-center align-middle">
                                Frecuencia
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dato.position }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.description_position }}
                              </td>
                              <td class="align-middle">
                                <li v-for="item in dato.profile_job_evaluations">
                                  {{ item.evaluations_type.name }}
                                </li>
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.frequency }}
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/perfiles-cargo-ver/${dato.id}`,
                                      }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>
                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/perfiles-cargo-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteEvaluacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <PerfilesCargoPagination @loading="(load) => (loading = load)" ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
